import { Typography, useBreakpoint } from "@povio/ui";
import { cx } from "class-variance-authority";

import { SettingsIcon } from "@/assets/icons/ui/Settings";
import { AuthContext } from "@/data/auth/auth.context";

export const UserAvatarNavSection = () => {
  const isDesktop = useBreakpoint("xl");
  const { user: authUser } = AuthContext.useAuth();
  const profilePictureUrl = authUser?.profilePictureUrl || "/default-avatar.png";

  return (
    <div className="flex w-full cursor-pointer flex-row items-center gap-2-5">
      <div
        className="relative h-avatar-height-l w-avatar-height-l min-w-avatar-height-l rounded-avatar-rounding-default p-2"
        style={{
          backgroundColor: "transparent",
          backgroundImage: profilePictureUrl ? `url(${profilePictureUrl})` : "none",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className={cx("flex flex-col justify-center gap-0-5 text-left", isDesktop ? "w-[172px]" : "w-full")}>
        <Typography
          size="label-4"
          variant="prominent-1"
          className="truncate text-text-default-1"
        >
          {authUser?.user.name}
        </Typography>
        <Typography
          size="label-3"
          className="truncate text-text-default-2"
        >
          {authUser?.user?.email}
        </Typography>
      </div>
      <SettingsIcon className="h-5 w-6 text-interactive-text-secondary-idle" />
    </div>
  );
};
